import { forwardRef } from "react";
import PropTypes from "prop-types";

import { iconClose } from "assets/icons";
import { InputSearchContainer } from "./Form.styles";
import { SearchIconV2 } from "assets/icons";

export const InputSearch = forwardRef(
  ({ handleChange, clearSearch, value, ...props }, ref) => {
    return (
      <InputSearchContainer className="input-search-container">
        <SearchIconV2
          fill={props.fill ? props.fill : "none"}
          className="search-icon"
        />

        <input
          ref={ref}
          autoComplete="off"
          id="search"
          placeholder="Search"
          onChange={handleChange}
          type="text"
          value={value}
          {...props}
          className={"search-input " + props?.className}
        />
        {/* {!value && <div className="keyboard-shortcut">⌘K</div>} */}
        {value && (
          <img src={iconClose} className="clear-search" onClick={clearSearch} />
        )}
      </InputSearchContainer>
    );
  }
);

InputSearch.displayName = "InputSearch";

InputSearch.propTypes = {
  value: PropTypes.string,
  handleChange: PropTypes.func,
  clearSearch: PropTypes.func,
  className: PropTypes.string,
  fill: PropTypes.string,
};
